export const MAX_VIEWS = 1_000_001;
